<template>
  <el-card shadow="never">
    <template #header>
      <div class="header">
        <el-breadcrumb class="breadcrumb" separator="/">
          <el-breadcrumb-item>设置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </template>
    <div style="width:80%">
      <el-form :model="form" label-width="180px">
        <el-tabs v-model="form.seller_id" class="demo-tabs" @tab-click="handleClick">
          <el-tab-pane :label="item.store_name" v-for="item in baseData.sellerList" :name="item.store_id" v-bind:key="item.store_id"></el-tab-pane>
        </el-tabs>
        <el-form-item label="定时同步开关">
          <el-switch v-model="form.status" />
        </el-form-item>
        <div v-for="item in baseData.locations_info" :key="item">
          <el-divider content-position="left">{{item.name}}({{ item.country_code }})</el-divider>
          <el-form-item label="" >
            <el-checkbox-group
              v-model="item.wids"
            >
              <el-checkbox v-for="item1 in baseData.warehouse_list" :key="item1.wid" :label="item1.wid" :value="item1.wid">
                {{ item1.name }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="success" @click="save">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-card>
</template>
<script lang="ts" setup>
import { reactive, onMounted } from 'vue'
import api from '@/api/index'
import { ElMessage, ElLoading } from 'element-plus'
const form = reactive({
  store_id:"",
  seller_id:"",
  status:true,
  platform_code:10016,
})
const baseData:any = reactive({
  sellerList:[],
  warehouse_list:[],
  locations_info:[],
})
const handleClick = () => {
  getSellerList()
}
const getSellerList = () => {
    const loading = ElLoading.service({lock: true})
    api.lingxingApi.getSellerList({platform_code:form.platform_code}).then((res:any)=>{
      if(res.code==200){
        baseData.sellerList = res.data.list
        if(!form.seller_id){
          form.seller_id = res.data.list[0].store_id
          form.status = res.data.list[0].status ? true : false
        }else{
          form.status = res.data.list.find((item:any)=>item.store_id==form.seller_id).status ? true : false
        }
        get_warehouse_location_list()
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
const get_warehouse_location_list = () => {
  const loading = ElLoading.service({lock: true})
  api.accessoryApi.get_warehouse_location_list({seller_id:form.seller_id}).then((res:any)=>{
    if(res.code==200){
      baseData.locations_info = res.data.locations_info
      baseData.warehouse_list = res.data.warehouse_list
    }else{
      ElMessage.error(res.message)
    }
    loading.close()
  })
}
const save =  () => { 
  const loading = ElLoading.service({lock: true})
  let status = form.status ? 1 : 0
  api.accessoryApi.save_warehouse_location_list({seller_id:form.seller_id, status:status, locations_info: baseData.locations_info}).then((res:any)=>{
    if(res.code==200){
    
      ElMessage({
        message: res.message,
        type: 'success',
      })
      get_warehouse_location_list()
    }else{
      ElMessage.error(res.message)
    }
    loading.close()
  })
}

onMounted(() => {
  getSellerList()
})
</script>